export const createAction = (type) => {
  const creator = (payload) => ({ type, ...payload });
  creator.toString = () => type;
  return creator;
};

export const createSetterActions = (name, propNames) =>
  propNames.map((propName) => {
    const type = `${name}/SET_${propName}`;
    const creator = (value) => ({ type, value });
    creator.toString = () => type;
    return creator;
  });
